<template>
    <div class="__item-chat" :class="{ __me: isCurrentUser }">
        <img v-if="!isCurrentUser && message.sender.profile_picture" class="user-profile" v-show="message.show_profile"
            :src="$fullUrl('images/profiles/' + message.sender.profile_picture)" />
        <img v-if="!isCurrentUser && !message.sender.profile_picture" class="user-profile" src="@/assets/avatar.png"
            v-show="message.show_profile" />
        <div class="__text" :class="{ expand: !message.show_profile }">
            <div class="message-header">
                <span class="name">{{ isCurrentUser ? 'You,' : senderName }}</span>
                <span class="time">{{ message.updated_at | formatDateTime | validate }}</span>
            </div>
            <div class="message-body" v-linkified>
                <div class="message-content">
                    <div class="image-message" v-if="message.new_file_name && message.file_type == 'image'">
                        <img :src="$fullUrl('files/messages/' + message.new_file_name)" />
                    </div>
                    <div class="video-message" v-if="message.new_file_name && message.file_type == 'video'">
                        <video controls :src="$fullUrl('files/messages/' + message.new_file_name)" />
                    </div>
                    <div class="document-message" v-if="message.new_file_name && message.file_type == 'file'">
                        <div class="document-widget">
                            <img src="@/assets/file-icon/file.svg" />
                            <h4>{{ message.new_file_name }}</h4>
                        </div>
                        <a class="btn-download" :href="$fullUrl('files/messages/' + message.new_file_name)"
                            target="_blank" download="true">Download</a>
                    </div>
                    <span v-html="urlify(message.message)"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatMessage',
    props: {
        message: {
            type: Object,
            required: true
        },
        senderName: {
            type: String,
            required: true
        },
        isCurrentUser: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        urlify(text) {
            if (text) {
                var urlRegex = /(https?:\/\/[^\s]+)/g;
                return text.replace(urlRegex, function (url) {
                    return '<a target="_blank" href="' + url + '">' + url + '</a>';
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.__item-chat {
    display: flex;
    background: transparent;
    align-items: flex-start;
    padding: 10px 0;

    img.user-profile {
        width: 25px;
        border-radius: 100%;
        height: 25px;
        margin-right: 10px;
        margin-top: 5px;

        &.hide {
            display: none;
        }
    }

    .__text {
        display: flex;
        text-align: left;
        border-radius: 5px;
        flex-direction: column;
        align-items: flex-start;

        .message-header {
            .name {
                font-size: 9px;
                text-transform: capitalize;
                color: #808080;
                margin-right: 10px;
            }

            .time {
                font-size: 9px;
                color: #b3b3b3;
            }
        }

        .message-body {
            text-align: left;
            background: rgb(234, 234, 234);
            border-radius: 10px 10px 10px 0px;
            padding: 8px 8px;
            word-break: break-word;
            line-height: 14px;
            font-size: 13px;
            margin-bottom: 0 !important;
            font-weight: normal;

            .message-content {
                width: 100%;
                color: #000000;
                text-align: justify;

                .image-message {
                    width: 100%;

                    img {
                        width: 100%;
                    }
                }

                .video-message {
                    width: 100%;

                    video {
                        width: 100%;
                    }
                }

                .document-message {
                    .document-widget {
                        display: flex;
                        align-items: center;
                        width: 96%;

                        img {
                            margin-right: 10px;
                        }

                        h4 {
                            overflow: hidden;
                            text-decoration: none;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 100%;
                        }
                    }

                    .btn-download {
                        display: flex;
                        align-items: center;
                        background: #1ba5a4;
                        border-radius: 5px;
                        font-size: 13px;
                        padding: 0px 13px;
                        color: #fff;
                        height: 40px;
                    }
                }

                span {
                    line-height: 10px;

                    a {
                        color: #28a5a4 !important;
                    }
                }
            }
        }
    }

    .__text.expand {
        margin-left: 34px;
    }

    &.__me {
        flex-direction: row-reverse;
        text-align: right;

        .__text {
            align-items: flex-end;

            .message-header {
                .name {
                    margin-right: 5px;
                }
            }

            .message-body {
                text-align: right;
                font-size: 13px;
                font-weight: lighter;
                background: rgb(27, 165, 164);
                word-break: break-word !important;
                color: #ffffff;
                padding: 8px 8px;
                border-radius: 10px 10px 0px;

                .message-content {
                    color: #fff;
                }
            }
        }
    }
}
</style>